<template>
    <div>
        <user-menu />
        <div class="wrapper">
            <EnterpriseAdminSidebarMenu 
                :readOnly="isReadOnly"
            />
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div>
                        <h3 class="d-inline heading">Enterprise</h3>                        
                    </div>
                    <div class="heading-seperator"></div>
                    <div class="margin-bottom-10"></div>
                    <div class="">
                        <flash-message autoHide variant="success"></flash-message>
                        
                    </div>
                    <div class="margin-bottom-10"></div>
                    <div>
                        <b-card no-body class="manage_locations">
                            <div class="row">
                                <div class="font-weight-bold">Enterprise Admin</div>
                                <a  class="add-new-admin" href="javascript:void(0)" @click="openNewEnterpriseAdmin">Add New</a>
                            </div>
                            <div class="list_locations">
                                <div class="row enterprise-head-row">
                                    <div
                                        class="col-md-3">
                                        Name                                        
                                    </div>
                                    <div
                                        class="col-md-4">
                                        Email                                        
                                    </div>
                                    <div
                                        class="col-md-2">
                                        Phone Number                                       
                                    </div>
                                    <div
                                        class="col-md-2 text-center">
                                        Password
                                    </div>
                                    <div
                                        class="col-md-1 text-center">
                                        Active
                                    </div>
                                    
                                </div>
                                <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                                <div v-if="adminUsers.length > 0" class="row_items">
                                    <div class="row_data_border row" v-for="(user, index) in adminUsers" :key="index">
                                        <div class="col-md-3"> {{ user.first_name }} {{ user.last_name }}</div>
                                        <div class="col-md-4"><i class="fa fa-envelope-o overview-icons"></i>&nbsp;{{ user.email }}</div>
                                        <div class="col-md-2">{{ (user.phone) ? user.phone : "Not Given" }}</div>
                                        <div class="col-md-2 text-center">
                                            <a class="offcanvas_link" @click="openResetLinkModal(user)"> Reset</a>
                                        </div>
                                        <div class="col-md-1 text-center">
                                        <input type="checkbox" :checked=" user.status == 'Active'?true:''"></div>
                                        
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                
                            </div>
                        </b-card>
                    </div>
                    <div class="margin-bottom-10"></div>
                    
                     <div>
                        <b-card no-body class="manage_locations">
                            <div>                                
                                <h3 class="d-inline heading" style="margin-left: -15px;">Enterprise Account Activity</h3>
                                <a class="print_icons" href="javascript:void(0)" @click="goToPrint">
                                    <i class="fa fa-print"></i>
                                </a>
                            </div>
                            <div class="list_locations">
                               <div class="row enterprise-head-row">
                                    <div
                                        class="col-md-5">
                                        Event                                        
                                    </div>
                                    <div
                                        class="col-md-2">
                                        Admin                                        
                                    </div>
                                    <div
                                        class="col-md-2" v-on:click="sortMethod('updatedOn')">
                                        Date  
                                        <i v-if="sortField == 'updatedOn' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'updatedOn' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>               

                                    </div>
                                    <div
                                        class="col-md-2">
                                        Time
                                    </div>
                                    <div
                                        class="col-md-1">
                                        &nbsp;
                                    </div>
                                    
                                </div>
                                <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                                <div  class="row_items">
                                    <div class="row_data_border row" v-for="(activity, aindex) in activityData" :key="aindex">
                                        <div class="col-md-5">{{activity.logMessage}}</div>
                                        <div class="col-md-2">{{activity.updatedBy}}</div>
                                        <div class="col-md-2">{{activity.updatedDate}}</div>
                                        <div class="col-md-2">
                                            {{activity.updatedTime}} (CST)
                                        </div>
                                        <div class="col-md-1">&nbsp; </div>
                                        
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                               
                            </div>
                                                                   
                        </b-card>
                    </div>                                                                        
                </div>
            </div>
        </div>

         <ResetLinkModal 
            :isModalVisible="isResetLinkModal" 
            ref="reset_modal_popup"
            @close="closeResetLinkModal"
        />

         <AddNewEnterpriseAdmin
            :isModalEAdminVisible="isModalEAdminVisible"             
            @close="closeEnterpriseAdminSidebar"
            ref="add_new_eadmin" 
        />

    </div>
</template>
<script>
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import ResetLinkModal from './loation_reset_modal.vue';
import router from '../../router/index.js';
import { store } from '../../store/store';
import AddNewEnterpriseAdmin from './add_new_enterpriseadmin.vue';

export default {
    data() {
        return {
            loading: false,
            isModalVisible: false,            
            adminUsers: [],
            activityData: [],
            isResetLinkModal: false,
            isModalEAdminVisible: false,         
            isReadOnly: false,   
            sortBy: '',
            sortField: '',
        }
    },
    components: {
        UserMenu,
        EnterpriseAdminSidebarMenu,
        ResetLinkModal,
        AddNewEnterpriseAdmin
    },    
    methods: {        
        openResetLinkModal(user) {
            this.isResetLinkModal = true;
            this.$refs.reset_modal_popup.setUserInfo(user);
        },
        closeResetLinkModal() {
            this.isResetLinkModal = false;
            this.$refs.reset_modal_popup.setUserInfo({});
        },
        sortMethod(field) {
            this.sortField = field;
            if(this.sortBy == 'ASC') {
                this.sortBy = 'DESC';
            }
            else {
                this.sortBy = 'ASC';
            }
            this.getEnterpriseAccountActivity();
        },
        getEnterpriseAccountActivity() {
           this.activityData = [];
           const params = {  };
            if (this.sortField) {
                params.sortfield = this.sortField;
            }
            if (this.sortBy) {
                params.sortby = this.sortBy;
            }
            axios.get('/enterprise_account_activity', {
                 params: params
              })
            .then(resp => {
                this.activityData = resp.data;                          
            })
            .catch(() => {
            });
        },
        goToPrint(){             
            router.push('/print-enterprise-accavtivity')
        },
        openNewEnterpriseAdmin() {
            this.isModalEAdminVisible = true;                       
        },
        closeEnterpriseAdminSidebar() {
            this.isModalEAdminVisible = false;
        }
    },
    created() {
        store.dispatch('clear_search_enterprise_locations');
        axios('/enterprise_info_admin_list',
        {
            method: 'GET',
        })
        .then(resp => {
            this.adminUsers = resp.data;
            this.getEnterpriseAccountActivity();           
        })
        .catch(() => {
        });

        axios('/enterprise-admin-info',
        {
            method: 'GET',
        })
        .then(resp => {
            if (resp.data.account.enterprise_type === 'Readonly') {
                this.isReadOnly = true;
            } else {
                this.isReadOnly = false;
            }
        })
        .catch(() => {
        });
        
    },
}
</script>
<style scoped>
.manage_locations { padding: 1rem 2rem 0rem 2rem; background-color: #FFF !important; }
.list_locations { padding: 0 1rem; margin: 1rem 0; }
.location_header { float: left; font-weight: 900; margin-top: 15px; }
.enterprise-head-row { font-weight: bold; }
.row_items { margin-right: -15px; margin-left: -15px }
.row_data_border { padding: 5px 0; margin: 10px 0; font-size: 14px;border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.ea-group-name, .ea-quick-link {
  text-decoration: underline !important;
  cursor: pointer;
}
.offcanvas_link { color: #00acee !important; text-decoration: underline !important; font-weight: 900; cursor: pointer; }
.loading_show { height: auto; }
.print_icons { font-size: 1.5rem;float: right; margin: 1px 0; color: #000 !important; }
.heading { padding-left: 0px; }
.add-new-admin { padding-left: 40px; text-decoration: underline; color: #00acee; font-weight: 900; }
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterprise_info.vue